// extracted by mini-css-extract-plugin
module.exports = {"wysiwyg":"Wysiwyg_wysiwyg__uGiES","tableWrapper":"Wysiwyg_tableWrapper__QEiMv","alert":"Wysiwyg_alert__BmPle"};